import script from "./FriendlyString.vue?vue&type=script&lang=ts&setup=true"
export * from "./FriendlyString.vue?vue&type=script&lang=ts&setup=true"

import "./FriendlyString.vue?vue&type=style&index=0&id=d2db8568&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2db8568"]])

export default __exports__